import { TenantTechnicalAssistance } from "../../Models/TenantTechnicalAssistance";
import api from "../axios";

export const tenantTechnicalAssistanceService = {
  get: async (): Promise<TenantTechnicalAssistance> => {
    const response = await api.get("/tenant-technical-assistance");
    return response.data;
  },

  create: async (data: Omit<TenantTechnicalAssistance, "id">): Promise<string> => {
    const response = await api.post("/tenant-technical-assistance", data);
    return response.data;
  },

  update: async (data: TenantTechnicalAssistance): Promise<boolean> => {
    const response = await api.put("/tenant-technical-assistance", data);
    return response.data;
  }
};
